import React, { useContext, useEffect, useState } from "react";
import FieldDate from "../../../../common/component/form/FieldDate";
import FieldText from "../../../../common/component/form/FieldText";
import LayoutCreateOrder from "../../../../common/layout/LayoutCreateOrder";
import { path } from "../../../../constants/apiPath";
import { StoreContext } from "../../../../store";
import { StoreContext as OldStoreContext } from "../../../../../store/Provider";
import { useLocation, useNavigate } from "react-router-dom";
import instance from "../../../../common/api/interceptor";
import moment from "moment";
import useForm from "../../../../common/hooks/useForm";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { NotificationManager } from "react-notifications";
import ModalOrderSpecificsContainer from "../../../../constants/data/ModalOrderSpecificsContainer";
import { userRole } from "../../../../utils/utility";
import OrderMilstonesCollection from "../../../../constants/data/MileStoneCollection";
import { LOCAL_STORAGE_KEY } from "../../../../../config";

function OrderSpecific() {
  const [milestone, setMileStone] = useState([
    ...JSON.parse(JSON.stringify(OrderMilstonesCollection)),
  ]);

  const navigate = useNavigate();
  const context = useContext(StoreContext);
  const oldContext = useContext(OldStoreContext);

  const [edit, setEdit] = useState(false);

  const orderNumber = useForm();
  const cwOrderNumber = useForm();
  const adviceNumber = useForm();
  const weight = useForm();
  const volume = useForm();
  const chargeableWeight = useForm();
  const invoiceNumber = useForm();
  const goodsDescription = useForm();
  const additionalTerms = useForm();
  const confirmNumber = useForm();
  const orderDate = useForm();

  //milestone
  const reqWorkDate = useForm();
  const reqStoreDate = useForm();
  const OriginFactory = useForm();
  const recieverNameRequire = useForm();

  const [supplierName, setSupplierName] = useState({ OrgCode: "" });
  const [supplierNameAdmin, setSupplierNameAdmin] = useState([]);
  const [reciverNameAdmin, setReciverNameAdmin] = useState([]);
  const [supplierAddress, setSupplierAddress] = useState({ Address1: "" });
  const [recieverAddress, setRecieverAddress] = useState({ Address1: "" });
  const [transportMode, setTransportMode] = useState({
    Description: "",
    Mode: "",
  });
  const [currency, setCurrency] = useState({ Code: "" });
  const [incoTerm, setIncoTerm] = useState({ Code: "" });
  const [originCountry, setOriginCountry] = useState({ Description: "" });
  const [containerMode, setContainerMode] = useState({ Mode: "" });
  const [serviceLevel, setServiceLevel] = useState({ Description: "" });
  const [containerCountInfo, setContainerCountInfo] = useState([]);
  const location = useLocation();

  const [reciverName, setReciverName] = useState({ OrgCode: "" });
  const [senderAddOptions, setSenderAddOptions] = useState([]);
  const [reciverAddOptions, setReciverAddOptions] = useState([]);

  const [sendingAgent, setSendingAgent] = useState({ OrgCode: "" });
  const [recivingAgent, setRecivingAgent] = useState({ OrgCode: "" });
  const [sendingOptions, setSendingOptions] = useState([]);
  const [recivingOptions, setRecivingOptions] = useState([]);
  const [deleveryAddress, setDeleveryAddress] = useState({ Address1: "" });
  const [deleveryOptions, setDeleveryOptions] = useState([]);

  const currencycode = useForm();
  const container = useForm();
  const inco = useForm();

  useEffect(() => {
    const userdata = oldContext.omsUserData;
    if (userdata?.UserRoles.includes("Buyer")) {
      getSupplierBuyerListforAdmin("Buyer");
    } else if (userdata?.UserRoles.includes("Supplier")) {
      getSupplierBuyerListforAdmin("Supplier");
    } else if (userdata?.UserRoles.includes("Admin")) {
      getSupplierBuyerListforAdmin("Buyer");
      getSupplierBuyerListforAdmin("Supplier");
    }
    context.setUserData(userdata);
    if (oldContext.omsUserData?.UserRoles.includes("Buyer")) {
      getAgentOrCarrier("ReceivingAgent", userdata.OrgPK);
      getAgentOrCarrier("SendingAgent", userdata.OrgPK);
    }
  }, []);

  useEffect(() => {
    setSendingAgent({ OrgCode: "" });
    setRecivingAgent({ OrgCode: "" });
    if (
      oldContext.omsUserData?.UserRoles.includes("Supplier") &&
      reciverName.OrgCode
    ) {
      getAgentOrCarrier("ReceivingAgent", reciverName.OrgPk);
      getAgentOrCarrier("SendingAgent", reciverName.OrgPk);
    }
    if (
      oldContext.omsUserData?.UserRoles.includes("Admin") &&
      reciverName.OrgCode
    ) {
      getAgentOrCarrier("ReceivingAgent", reciverName.OrgPk);
      getAgentOrCarrier("SendingAgent", reciverName.OrgPk);
    }
  }, [reciverName.OrgCode]);

  const getSupplierList = () => {
    instance
      .get(path.GET_BUYER_SUPPIER)
      .then((res) => {
        context.setSupplierName(res.data ?? []);
        setSupplierName(
          getOptions(
            res.data,
            "OrgCode",
            context.orderJSON.OrderHeader.OrderSupplierCode,
            "OrgCode"
          )
        );
        setReciverName(
          getOptions(
            res.data,
            "OrgCode",
            context.orderJSON.OrderHeader.OrderBuyerCode,
            "OrgCode"
          )
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getSupplierBuyerListforAdmin = (role = "", code = "") => {
    instance
      .get(`${path.GET_BUYER_SUPPIER}?code=${role}&OrgCodes=${code}`)
      .then((res) => {
        if (role === "Supplier") {
          setSupplierNameAdmin(res.data);
          if (
            oldContext.omsUserData?.UserRoles.includes("Supplier") &&
            res.data.length === 1 &&
            res.data
          ) {
            onSupplierChange(res.data[0]);
          }
        } else if (role === "Buyer") {
          setReciverNameAdmin(res.data);
          if (
            oldContext.omsUserData?.UserRoles.includes("Buyer") &&
            res.data.length === 1 &&
            res.data
          ) {
            onbuyierChange(res.data[0]);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAgentOrCarrier = (type, orgPk) => {
    const url = `${path.AGENT_CARRIER}${type}&orgPk=${orgPk}`;
    instance
      .get(url)
      .then((res) => {
        console.log(type, res.data);  
        // return res.data ?? [];
        if (type === "ReceivingAgent") {
          if (res.data.length === 1) {
            setRecivingAgent(res.data[0]);
          }
          setRecivingOptions(res.data ?? []);
        } else if (type === "SendingAgent") {
          if (res.data.length === 1) {
            setSendingAgent(res.data[0]);
          }
          setSendingOptions(res.data ?? []);
        }
      })
      .catch(() => {
        return [];
      });
  };

  useEffect(() => {
    const data = context.orderJSON.OrderHeader;
    orderNumber.setValue(data.OrderNumber);
    adviceNumber.setValue(data.OrderPreAdviceId);
    invoiceNumber.setValue(data.OrderInvoiceNumber);
    goodsDescription.setValue(data.OrderGoodsDescription);
    additionalTerms.setValue(data.OrderSpecialInstruction);
    confirmNumber.setValue(data.OrderConfirmNumber);
    weight.setValue(data.OrderActualWeight);
    volume.setValue(data.OrderActualVolume);
    chargeableWeight.setValue(data.OrderChargeableWeight);
    const arr = [];

    setSendingAgent({
      OrgCode: data.OrderSendingAgentCode ?? "",
      OrgPk: data.OrderSendingAgentPK ?? "",
    });

    setDeleveryAddress({
      Address1: data?.OrderBuyerDeliveryAddress1 ?? "",
      AddressPk: data?.OrderBuyerDeliveryAddressPK ?? "",
    });

    setRecivingAgent({
      OrgCode: data.OrderReceivingAgentCode ?? "",
      OrgPk: data.OrderReceivingAgentPK ?? "",
    });

    setReciverName({
      OrgCode: data.OrderBuyerCode ?? "",
      OrgPk: data.OrderBuyerPK ?? "",
    });

    setSupplierName({
      OrgCode: data.OrderSupplierCode ?? "",
      OrgPk: data.OrderSupplierPK ?? "",
    });
    if (context.orderJSON.OrderMilstonesCollection.length) {
      setMileStone([...context.orderJSON.OrderMilstonesCollection]);
    }
    setSupplierAddress({
      Address1: data.OrderSupplierAddress1,
      AddressPk: data.OrderSupplierAddressPK,
    });
    setRecieverAddress({
      Address1: data.OrderBuyerAddress1,
      AddressPk: data.OrderBuyerPK,
    });
    data.OrderContainerCollection.map((ele, index) => {
      const obj = {
        ...ele,
        OrderContainerType: { Code: ele.OrderContainerType },
      };
      arr.push(obj);
    });
    setContainerCountInfo([...arr]);
    reqWorkDate.setValue(data.OrderExWorksRequiredBy ?? "");
    reqStoreDate.setValue(data.OrderDeliveryRequiredBy ?? "");
    OriginFactory.setValue(data.PickupfromOriginFactory ?? "");
    orderDate.setValue(data.OrderDate ?? "");
    setServiceLevel(
      getOptions(
        context.defaultValue.serviceLevel,
        "Code",
        data.OrderServiceLevelcode
      )
    );
    setTransportMode(
      getOptions(
        context.defaultValue.transportMode,
        "Mode",
        data.OrderTransportMode
      )
    );
    setCurrency({ Code: data.OrderCurrencyCode });
    setContainerMode({ Mode: data.OrderContainerMode });
    setOriginCountry(
      getOptions(
        context.defaultValue.originCountry,
        "Description",
        data.OrderCountryOfOrigin
      )
    );
    setIncoTerm({ Code: data.OrderIncoTerm });
    setEdit(location?.state?.edit ?? false);
  }, [context.orderJSON]);

  const getOptions = (data = [], key, value, item = "Description") => {
    const arr = [...data] ?? [];
    const result = arr.filter((word) => word[key] === value);
    return result.length ? result.pop() : { [item]: "" };
  };

  const onNextHandler = (path) => {
    let flag = false;
    if (reciverName.OrgCode === "") {
      recieverNameRequire.setError(true);
      recieverNameRequire.setErrorMsg("Buyer Name required");
      flag = true;
    }

    if (containerMode.Mode === "") {
      container.setError(true);
      container.setErrorMsg("Container type required");
      flag = true;
    }

    if (incoTerm.Code === "") {
      inco.setError(true);
      inco.setErrorMsg("Inco term required");
      flag = true;
    }

    if (currency.Code === "") {
      currencycode.setError(true);
      currencycode.setErrorMsg("Currency code required");
      flag = true;
    }

    if (!flag) {
      const orderNo = orderNumber.value
        ? orderNumber.value
        : Math.floor(Math.random() * 10000 + 1);
      console.log("orderNo", orderNo);

      const containerInfo = [];
      containerCountInfo.map((item) => {
        const con = {
          OrderContainerCountTypePk: item.OrderContainerCountTypePk,
          OrderContainerCountTypeOrderFK: item.OrderContainerCountTypeOrderFK,
          OrderContainerCount: item.OrderContainerCount,
          OrderContainerType: item.OrderContainerType.Code ?? "",
        };

        containerInfo.push(con);
      });

      const body = {
        ...context.orderJSON,
        OrderHeader: {
          ...context.orderJSON.OrderHeader,
          OrderContainerMode: containerMode.Mode ?? "",
          OrderConfirmDate: moment().format("YYYY-MM-DD HH:mm:ss"),
          SplitNumber: "0",
          OrderConfirmNumber: confirmNumber.value ?? "",
          OrderCountryOfOrigin: originCountry.Description ?? "",
          OrderCurrencyCode: currency.Code,
          OrderDate: orderDate.value
            ? moment(orderDate.value).format("YYYY-MM-DD HH:mm:ss")
            : moment().format("YYYY-MM-DD HH:mm:ss"),
          OrderDeliveryRequiredBy: reqStoreDate.value
            ? moment(reqStoreDate.value).format("YYYY-MM-DD HH:mm:ss")
            : "",
          PickupfromOriginFactory: OriginFactory.value
            ? moment(OriginFactory.value).format("YYYY-MM-DD HH:mm:ss")
            : "",
          OrderExWorksRequiredBy: reqWorkDate.value
            ? moment(reqWorkDate.value ?? "").format("YYYY-MM-DD HH:mm:ss")
            : "",
          OrderIncoTerm: incoTerm.Code ?? "",
          OrderInvoiceNumber: invoiceNumber.value ?? "",
          OrderNumber: orderNo ?? "",
          OrderServiceLevelcode: serviceLevel.Code ?? "",
          OrderStatus: "PLC",
          OrderTransportMode: transportMode?.Mode ?? "",
          OrderGoodsDescription: goodsDescription.value,
          OrderSpecialInstruction: additionalTerms.value,
          OrderPreAdviceId: adviceNumber.value,
          Is_SupplierMainorder: false,
          //buyer
          OrderBuyerCode: reciverName.OrgCode ?? "",
          OrderBuyerPK: reciverName.OrgPk ?? "",
          OrderBuyerAddressPK: recieverAddress?.AddressPk ?? "",
          OrderBuyerAddress1: recieverAddress.Address1 ?? "",
          OrderBuyerDeliveryAddressPK: deleveryAddress.AddressPk,
          OrderBuyerDeliveryAddress1: deleveryAddress?.Address1 ?? "",

          //supllier
          OrderSupplierPK: supplierName.OrgPk ?? "",
          OrderSupplierCode: supplierName.OrgCode ?? "",
          OrderSupplierAddressPK: supplierAddress.AddressPk ?? "",
          OrderSupplierAddress1: supplierAddress.Address1 ?? "",
          OrderChargeableWeight: transportMode?.Mode?.includes("AIR")
            ? chargeableWeight.value
            : "",
          OrderActualVolume: transportMode?.Mode?.includes("SEA")
            ? volume.value
            : "",
          OrderActualWeight: transportMode?.Mode?.includes("SEA")
            ? weight.value
            : "",
          OrderSendingAgentPK: sendingAgent.OrgPk ?? "",
          OrderSendingAgentCode: sendingAgent.OrgCode ?? "",
          OrderReceivingAgentCode: recivingAgent.OrgCode ?? "",
          OrderReceivingAgentPK: recivingAgent.OrgPk ?? "",

          OrderContainerCollection: [...containerInfo],
        },
         OrderMilstonesCollection: [...milestone],
         OrderNotesCollection: [],
        
        
      };

      console.log("order specific json", body);
      context.setOrderJSON({ ...body });
      navigate(path, {
        state: { edit: edit },
      });
    } else {
      NotificationManager.error("Mandatory fields required", "", 3000);
    }
  };

  const getOrgAddress = (option, orgCode = "") => {
    if (option === "sender") {
      instance
        .get(`${path.GET_ORG_CONTACTS}?orgcode=${orgCode}`)
        .then((res) => {
          if (res.Is_Success) {
            setSenderAddOptions(res.data[0].Addresses);
          } else {
            NotificationManager.error(res.Message, "", 3000);
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
            NotificationManager.error(err.response.data.Message, "", 3000);
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
        });
    } else {
      instance
        .get(`${path.GET_ORG_CONTACTS}?orgcode=${orgCode}`)
        .then((res) => {
          if (res.Is_Success) {
            setReciverAddOptions(res?.data[0]?.Addresses ?? []);
            setDeleveryOptions(res?.data[0]?.DeliveryAddresses ?? []);
          } else {
            NotificationManager.error(res.Message, "", 3000);
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
            NotificationManager.error(err.response.data.Message, "", 3000);
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
        });
    }
  };

  useEffect(() => {
    if (supplierName.OrgCode) {
      getOrgAddress("sender", supplierName.OrgCode);
    }
  }, [supplierName]);

  useEffect(() => {
    if (reciverName.OrgCode) {
      getOrgAddress("reciver", reciverName.OrgCode);
    }
  }, [reciverName]);

  const onAddContainerCountInfo = () => {
    const containerCountArray = [...containerCountInfo];
    containerCountArray.push({
      ...ModalOrderSpecificsContainer,
    });
    setContainerCountInfo([...containerCountArray]);
  };

  const onRemoveContainerCountInfo = (itemIndex) => {
    const containerCountArray = [...containerCountInfo];
    containerCountArray.splice(itemIndex, 1);
    setContainerCountInfo([...containerCountArray]);
  };

  const onContainerHandler = (lable, value, arrIndex) => {
    let arr = [...containerCountInfo];
    arr.map((item, i, arr) => {
      if (lable == "OrderContainerCount") {
        arr[arrIndex][lable] = parseInt(value).toFixed(0);
      } else {
        arr[arrIndex][lable] = value;
      }
    });
    setContainerCountInfo([...arr]);
  };

  const onLineValueChange = (lable, value, index) => {
    const arr = [...milestone];
    arr[index][lable] = moment(value).format("YYYY-MM-DD HH:mm:ss");
    setMileStone([...milestone]);
  };

  const onSupplierChange = (newValue) => {
    setSupplierName(newValue ?? { OrgCode: "" });
    if (oldContext.omsUserData?.UserRoles.includes("Supplier")) {
      if (newValue) {
        getSupplierBuyerListforAdmin("Buyer", newValue.OrgCode);
      } else {
        setReciverNameAdmin([]);
      }
    }
  };
  const onbuyierChange = (newValue) => {
    recieverNameRequire.setError(false);
    setReciverName(newValue ?? { OrgCode: "" });
    if (oldContext.omsUserData?.UserRoles.includes("Buyer")) {
      if (newValue) {
        recieverNameRequire.setError(false);
        recieverNameRequire.setErrorMsg("");
        getSupplierBuyerListforAdmin("Supplier");
      } else {
        setSupplierNameAdmin([]);
      }
    }
  };

  return (
    <LayoutCreateOrder onNextHandler={onNextHandler} title="Edit Order">
      <div className="_form-div">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-7 col-12  _newOrderCol12">
              <div className="row">
                <div className="col-md-6 col-12 _newOrderCol1">
                  <h5>ORDER NUMBER</h5>
                  <div className="_newOrderCol1Content">
                    <FieldText
                      label={
                        <div className="_mandatoryfieldName">
                          Order number
                          <span className="_madatoryFieldSymbol">*</span>
                        </div>
                      }
                      value={orderNumber.value}
                      onChange={orderNumber.onChange}
                      error={orderNumber.error}
                      errorMsg={orderNumber.errorMsg}
                    />
                    <FieldText
                      label="CW1 Order Number"
                      value={cwOrderNumber.value}
                      onChange={cwOrderNumber.onChange}
                      error={cwOrderNumber.error}
                      errorMsg={cwOrderNumber.errorMsg}
                    />
                    <FieldDate
                      className="mb-0"
                      label={
                        <div className="_mandatoryfieldName">
                          Order Date
                          <span className="_madatoryFieldSymbol">*</span>
                        </div>
                      }
                      value={orderDate.value}
                      onChange={orderDate.onDateChange}
                      error={orderDate.error}
                      errorMsg={orderDate.errorMsg}
                    />
                    <div className={`width100`} style={{ marginTop: "1rem" }}>
                      <Autocomplete
                        disablePortal
                        disableClearable={false}
                        size="small"
                        value={sendingAgent}
                        onChange={(event, newValue) => {
                          if (!newValue) {
                            setSendingAgent({ OrgCode: "", OrgPk: "" });
                          } else {
                            setSendingAgent(newValue);
                          }
                        }}
                        options={sendingOptions ?? []}
                        getOptionLabel={(option) => option.OrgCode}
                        sx={{ width: 300 }}
                        renderInput={(params) => (
                          <TextField {...params} label="Sending Agent" />
                        )}
                      />
                    </div>
                    <div className={`width100`}>
                      <Autocomplete
                        disablePortal
                        disableClearable={false}
                        size="small"
                        value={recivingAgent}
                        onChange={(event, newValue) => {
                          if (!newValue) {
                            setRecivingAgent({ OrgCode: "", OrgPk: "" });
                          } else {
                            setRecivingAgent(newValue);
                          }
                        }}
                        options={recivingOptions ?? []}
                        getOptionLabel={(option) => option.OrgCode}
                        sx={{ width: 300 }}
                        renderInput={(params) => (
                          <TextField {...params} label="Receiving Agent" />
                        )}
                      />
                    </div>
                  </div>
                  <h5 className="my-3">Milestones</h5>
                  <div className="_orderTimelineDivParent">
                    {milestone.map((ele, index) => {
                      return (
                        <div className="_orderTimelineDiv">
                          <div className="_orderTimelineDotLine">
                            <div className="_orderTimelineDot "></div>
                            <div className="_orderTimelineLine" />
                          </div>
                          <div className="_orderTimelineInputs">
                            <h6>{ele.MilstoneDescription}</h6>
                            <FieldDate
                              label="Ext. Date"
                              value={ele.MilstoneEstimatedDate}
                              onChange={(text) => {
                                onLineValueChange(
                                  "MilstoneEstimatedDate",
                                  text,
                                  index
                                );
                              }}
                            />
                             <FieldDate
                              label="Actual Date"
                              value={ele.MilstoneActualDate}
                              onChange={(text) => {
                                onLineValueChange(
                                  "MilstoneActualDate",
                                  text,
                                  index
                                );
                              }}
                            /> 
                          </div>
                        </div>
                      );
                    })}
                  </div>
                   <div className="_orderTimelineDivParent">
                   
                   <div className="_orderTimelineDiv">
                     <div className="_orderTimelineDotLine">
                       <div className="_orderTimelineDot "></div>
                       <div className="_orderTimelineLine" />
                     </div>
                     <div className="_orderTimelineInputs">
                       <h6>Pickup from Origin Factory </h6>
                       <FieldDate
            
               label="Actual Date"
               value={OriginFactory.value}
               onChange={OriginFactory.onDateChange}
               error={OriginFactory.error}
               errorMsg={OriginFactory.errorMsg}
             />
                      
                     </div>
                   </div>
               
             </div> 
                </div>
                <div className="col-md-6 col-12 _newOrderCol2">
                  <div className="_orderTimelineDivParent">
                    <div className="_orderTimelineDiv">
                      <div className="_orderTimelineDotLine">
                        <div className="_orderTimelineDot solid"></div>
                        <div className="_orderTimelineLine" />
                      </div>
                      <div className="_orderTimelineInputs">
                        <h6>Supplier:</h6>
                        <div className={`width100`}>
                          <Autocomplete
                            disablePortal
                            disableClearable={false}
                            size="small"
                            value={supplierName}
                            onChange={(event, newValue) => {
                              onSupplierChange(newValue);
                            }}
                            options={supplierNameAdmin}
                            getOptionLabel={(option) => option.OrgCode}
                            sx={{ width: 300 }}
                            renderInput={(params) => (
                              <TextField {...params} label="Supplier Name" />
                            )}
                          />
                        </div>
                        <div className={`width100`}>
                          <Autocomplete
                            disablePortal
                            disableClearable={false}
                            size="small"
                            value={supplierAddress}
                            onChange={(event, newValue) => {
                              setSupplierAddress(newValue ?? { Address1: "" });
                            }}
                            options={senderAddOptions}
                            getOptionLabel={(option) => option.Address1}
                            sx={{ width: 300 }}
                            renderInput={(params) => (
                              <TextField {...params} label="Supplier Address" />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="_orderTimelineDiv">
                      <div className="_orderTimelineDotLine">
                        <div className="_orderTimelineDot solid"></div>
                      </div>
                      <div className="_orderTimelineInputs">
                        <h6>Buyer:</h6>
                        <div className={`width100`}>
                          <Autocomplete
                            disablePortal
                            disableClearable={false}
                            size="small"
                            value={reciverName}
                            onChange={(event, newValue) => {
                              onbuyierChange(newValue);
                            }}
                            options={reciverNameAdmin}
                            getOptionLabel={(option) => option.OrgCode}
                            sx={{ width: 300 }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={
                                  <div className="_mandatoryfieldName">
                                    Buyer Name
                                    <span className="_madatoryFieldSymbol">
                                      *
                                    </span>
                                  </div>
                                }
                                error={recieverNameRequire.error}
                                helperText={recieverNameRequire.errorMsg}
                              />
                            )}
                          />
                        </div>
                        <div className={`width100`}>
                          <Autocomplete
                            // disablePortal
                            disableClearable={false}
                            size="small"
                            value={recieverAddress ?? ""}
                            onChange={(event, newValue) => {
                              setRecieverAddress(newValue ?? { Address1: "" });
                            }}
                            options={reciverAddOptions}
                            getOptionLabel={(option) => option.Address1}
                            sx={{ width: 300 }}
                            renderInput={(params) => (
                              <TextField {...params} label="Buyer Address" />
                            )}
                          />
                        </div>
                        <div className={`width100`}>
                          <Autocomplete
                            disableClearable={false}
                            size="small"
                            value={deleveryAddress ?? ""}
                            onChange={(event, newValue) => {
                              setDeleveryAddress(newValue ?? { Address1: "" });
                            }}
                            options={deleveryOptions}
                            getOptionLabel={
                              (option) => {
                                let address = option.Address1
                                  ? `${option.Address1}`
                                  : "";
                                // let city = option.City
                                //   ? `${option.City}, `
                                //   : "";
                                // let state = option.State
                                //   ? `${option.State}, `
                                //   : "";
                                // let country = option.Country
                                //   ? `${option.Country}, `
                                //   : "";
                                // let postCode = option.PostCode
                                //   ? `${option.PostCode}`
                                //   : "";
                                // let fullAddress = `${address}${city}${state}${country}${postCode}`;
                                return address;
                              }
                              // option.Address1
                            }
                            sx={{ width: 300 }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Final Delivery Location"
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-5 col-12 _newOrderCol3">
              <h5>ORDER DETAILS</h5>
              <div className="row _newOrderCol3Content">
                <div className="col-sm-6 col-12">
                  <div className="width100">
                    <Autocomplete
                      disablePortal
                      disableClearable={false}
                      size="small"
                      value={currency}
                      onChange={(event, newValue) => {
                        console.log(newValue);
                        currencycode.setError(false);
                        currencycode.setErrorMsg("");
                        setCurrency(newValue ?? { Code: "" });
                      }}
                      options={context.defaultValue.currency}
                      getOptionLabel={(option) => option.Code}
                      sx={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <div className="_mandatoryfieldName">
                              Currency of payment
                              <span className="_madatoryFieldSymbol">*</span>
                            </div>
                          }
                          error={currencycode.error}
                          helperText={currencycode.errorMsg}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="width100">
                    <Autocomplete
                      disablePortal
                      disableClearable={false}
                      size="small"
                      value={incoTerm}
                      onChange={(event, newValue) => {
                        inco.setError(false);
                        inco.setErrorMsg("");
                        setIncoTerm(newValue ?? { Code: "" });
                      }}
                      options={context.defaultValue.incoTerm}
                      getOptionLabel={(option) => option.Code}
                      sx={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <div className="_mandatoryfieldName">
                              Inco Term
                              <span className="_madatoryFieldSymbol">*</span>
                            </div>
                          }
                          error={inco.error}
                          helperText={inco.errorMsg}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="width100">
                    <Autocomplete
                      disablePortal
                      disableClearable={false}
                      size="small"
                      value={containerMode}
                      onChange={(event, newValue) => {
                        container.setError(false);
                        container.setErrorMsg("");
                        setContainerMode(newValue ?? { Mode: "" });
                      }}
                      options={context.defaultValue.containerMode}
                      getOptionLabel={(option) => option.Mode}
                      sx={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <div className="_mandatoryfieldName">
                              Container Mode
                              <span className="_madatoryFieldSymbol">*</span>
                            </div>
                          }
                          error={container.error}
                          helperText={container.errorMsg}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="width100">
                    <Autocomplete
                      disableClearable={false}
                      disablePortal
                      size="small"
                      value={transportMode}
                      onChange={(event, newValue) => {
                        setTransportMode(newValue ?? { Description: "" });
                      }}
                      options={context.defaultValue.transportMode}
                      getOptionLabel={(option) => option.Description}
                      sx={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField {...params} label="Transport Mode" />
                      )}
                    />
                  </div>
                </div>
                {transportMode?.Mode?.includes("SEA") ? (
                  <>
                    <div className="col-sm-6 col-12 ">
                      <div className="width100">
                        <TextField
                          label={
                            <div className="_orderWtVolInputUnits">
                              <div>Weight</div>
                              <div>(kg)</div>
                            </div>
                          }
                          type="number"
                          pattern="[0-9.]*"
                          size="small"
                          value={weight.value}
                          onChange={weight.onChange}
                          error={weight.error}
                          errorMsg={weight.errorMsg}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <TextField
                        label={
                          <div className="_orderWtVolInputUnits">
                            <div>Volume</div>
                            <div>(cbm)</div>
                          </div>
                        }
                        type="number"
                        pattern="[0-9.]*"
                        size="small"
                        value={volume.value}
                        onChange={volume.onChange}
                        error={volume.error}
                        errorMsg={volume.errorMsg}
                      />
                    </div>
                  </>
                ) : null}
                {transportMode?.Mode?.includes("AIR") ? (
                  <div className="col-sm-6 col-12">
                    <TextField
                      label={
                        <div className="_orderWtVolInputUnits">
                          <div>Chargeable Weight</div>
                          <div>(kg)</div>
                        </div>
                      }
                      type="number"
                      pattern="[0-9.]*"
                      size="small"
                      value={chargeableWeight.value}
                      onChange={chargeableWeight.onChange}
                      error={chargeableWeight.error}
                      errorMsg={chargeableWeight.errorMsg}
                    />
                  </div>
                ) : null}
                <div className="col-sm-6 col-12">
                  <FieldDate
                    label="Req. Ex. Works"
                    value={reqWorkDate.value}
                    onChange={reqWorkDate.onDateChange}
                    error={reqWorkDate.error}
                    errorMsg={reqWorkDate.errorMsg}
                  />
                </div>
                <div className="col-sm-6 col-12">
                  <FieldDate
                    label="Req. In Store"
                    value={reqStoreDate.value}
                    onChange={reqStoreDate.onDateChange}
                    error={reqStoreDate.error}
                    errorMsg={reqStoreDate.errorMsg}
                  />
                </div>
                <div className="col-sm-6 col-12">
                  <div className="width100">
                    <Autocomplete
                      disablePortal
                      disableClearable={false}
                      size="small"
                      value={serviceLevel}
                      onChange={(event, newValue) => {
                        setServiceLevel(newValue ?? { Description: "" });
                      }}
                      options={context.defaultValue.serviceLevel}
                      getOptionLabel={(option) => option.Description}
                      sx={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField {...params} label="Service Level" />
                      )}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <FieldText
                    label="Shipment No."
                    value={adviceNumber.value}
                    onChange={adviceNumber.onChange}
                    error={adviceNumber.error}
                    errorMsg={adviceNumber.errorMsg}
                  />
                </div>
                {/* <div className="col-sm-6 col-12">
                  <FieldText
                    label="Confirm No."
                    value={confirmNumber.value}
                    onChange={confirmNumber.onChange}
                    error={confirmNumber.error}
                    errorMsg={confirmNumber.errorMsg}
                  />
                </div> */}
                <div className="col-sm-6 col-12">
                  <FieldText
                    label="Invoice No."
                    value={invoiceNumber.value}
                    onChange={invoiceNumber.onChange}
                    error={invoiceNumber.error}
                    errorMsg={invoiceNumber.errorMsg}
                  />
                </div>
                {/* <div className="col-sm-6 col-12">
                  <div className="width100">
                    <Autocomplete
                      disablePortal
                      disableClearable={true}
                      
                      size="small"
                      value={orderStatus}
                      onChange={(event, newValue) => {
                        setOrderStatus(newValue);
                      }}
                      options={context.defaultValue.orderStatus}
                      getOptionLabel={(option) => option.Description}
                      sx={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <div className="_mandatoryfieldName">
                              Order Status
                              <span className="_madatoryFieldSymbol">*</span>
                            </div>
                          }
                        />
                      )}
                    />
                  </div>
                </div> */}
                <div className="col-sm-6 col-12">
                  <div className="width100">
                    <Autocomplete
                      disableClearable={false}
                      disablePortal
                      size="small"
                      value={originCountry}
                      onChange={(event, newValue) => {
                        setOriginCountry(newValue ?? { Description: "" });
                      }}
                      options={context.defaultValue.originCountry}
                      getOptionLabel={(option) => option.Description}
                      sx={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField {...params} label="Origin Country" />
                      )}
                    />
                  </div>
                </div>
                <div className="col-12 _orderSpecificsContainerSection">
                  <div className="row">
                    <div className="col-12">
                      <h6>Containers Required</h6>
                    </div>
                  </div>
                  {containerCountInfo.map((item, index) => {
                    return (
                      <div className="row" key={index}>
                        <div className="col-md-4 col-sm-6 col-12">
                          <TextField
                            label="Count"
                            type="number"
                            pattern="[0-9]*"
                            size="small"
                            value={item.OrderContainerCount}
                            onChange={(e) => {
                              // alert(typeof (e.target.value))
                              if (parseInt(e.target.value) > 50) {
                                NotificationManager.error(
                                  "Container count is not more then 50 !!!!",
                                  "",
                                  3000
                                );
                              } else {
                                onContainerHandler(
                                  "OrderContainerCount",
                                  e.target.value,
                                  index
                                );
                              }
                            }}
                          />
                        </div>
                        <div className="col-md-4 col-sm-6 col-12">
                          <div className="width100">
                            <Autocomplete
                              disablePortal
                              disableClearable={false}
                              size="small"
                              value={item.OrderContainerType}
                              onChange={(event, newValue) => {
                                onContainerHandler(
                                  "OrderContainerType",
                                  newValue ?? { Code: "" },
                                  index
                                );
                              }}
                              options={context.defaultValue.containerType}
                              getOptionLabel={(option) => option.Code}
                              renderInput={(params) => (
                                <TextField {...params} label="Type" />
                              )}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 sol-sm-6 col-12">
                          <div className="_outlineButton">
                            <button
                              onClick={() => onRemoveContainerCountInfo(index)}
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <div className="row">
                    <div className="col-12">
                      <div className="_solidButton">
                        <button onClick={onAddContainerCountInfo}>
                          ADD CONTAINERS
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <FieldText
                    multiline={true}
                    label="Goods Description"
                    value={goodsDescription.value}
                    onChange={goodsDescription.onChange}
                    error={goodsDescription.error}
                    errorMsg={goodsDescription.errorMsg}
                  />
                </div>
                <div className="col-12">
                  <FieldText
                    className=""
                    multiline={true}
                    label="Special Instructions"
                    value={additionalTerms.value}
                    onChange={additionalTerms.onChange}
                    error={additionalTerms.error}
                    errorMsg={additionalTerms.errorMsg}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutCreateOrder>
  );
}

export default OrderSpecific;
